import React, {useEffect, useState} from 'react'
import {Feedback} from '../../model/models'
import LoadingBackdrop from '../../components/LoadingBackdrop'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import FeedbackApi from '../../logic/FeedbackApi'

const api = new FeedbackApi()

export default function FeedbackAdmin() {
  const [loading, setLoading] = useState<boolean>(false)
  const [feedbacks, setFeedbacks] = useState<Feedback[]>([])

  useEffect(() => {
    api.getAll()
      .then(res => {
        if (res.isError()) {
          console.error(res.exception?.toJson())
          return
        }
        setFeedbacks(res.data!)
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <>
      <LoadingBackdrop loading={loading}/>
      <h1>Feedback</h1>
      <TableContainer component={Paper} sx={{mb: 5}}>
        <Table sx={{minWidth: 650}}>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Feedback</TableCell>
              <TableCell>Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {feedbacks.map((feedback, idx) => (
              <TableRow key={idx} hover sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                <TableCell component="th" scope="row">
                  {feedback.name}
                </TableCell>
                <TableCell>
                  {feedback.email}
                </TableCell>
                <TableCell>
                  {feedback.feedback}
                </TableCell>
                <TableCell>
                  {new Date(`${feedback.timestamp}Z`).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
